export default __webpack_public_path__ + "394efeedf87f8dc6f754ff600051476e.svg";